import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';

import { Space } from 'antd';

import Attribution from './attribution';
import Details from './details';
import CompareSection from './filter/compare';
import CompareButton from './filter/CompareButton';
import DashboardFilter from './filter/DashboardFilter';
import PeriodSelector from './period';
import { IAttributionItem, IDetailItem } from '../../../../../app/types/filter';
import { useTypedSelector } from '../../../hooks/useTypedSelector';

interface IParamsProps {
  withAttribution?: boolean;
  attributionItems?: IAttributionItem[];
  withDetails?: boolean;
  detailsItems?: IDetailItem[];
  withCompare?: boolean;
  withSegments?: boolean;
  filtersFilter?: string[];
  isFilterVisible?: boolean;
  setUpdateDashboard: () => void;
  fetchDashboardDataButtonVisible?: boolean;
  setFetchDashboardDataButtonVisible?: Dispatch<SetStateAction<boolean>>;
}

const DashboardParams: FC<IParamsProps> = ({
  withAttribution = true,
  attributionItems,
  withDetails = true,
  detailsItems,
  withCompare = true,
  withSegments = true,
  filtersFilter,
  isFilterVisible = true,
  setUpdateDashboard,
  fetchDashboardDataButtonVisible = false,
  setFetchDashboardDataButtonVisible,
}) => {
  const { isCompare, isNotParamsFilterVisible } = useTypedSelector(
    (state) => state.meta
  );
  const [ stateAttributionItems, setStateAttributionItems ] = useState<IAttributionItem[]>([]);
  const [ stateDetailsItems, setStateDetailsItems ] = useState<IDetailItem[]>([]);
 

  useEffect(() => {
    if (attributionItems) {
      setStateAttributionItems(attributionItems);
    }
  }, [ attributionItems ]);

  useEffect(() => {
    if (detailsItems) {
      setStateDetailsItems(detailsItems);
    }
  }, [ detailsItems ]);

  return (
    <Space
      direction="vertical"
      style={{
        width: '100%',
        padding: '15px 15px 0px 25px',
        display: 'flex',
      }}
    >
      {!isCompare && <PeriodSelector isCompare={isCompare} />}
      <Space
        direction="horizontal"
        style={{
          position: 'relative',
          display: 'flex',
          flexWrap: 'wrap', 
        }}
      >
        {withAttribution && stateAttributionItems && (
          <div>
            <Attribution items={stateAttributionItems} isDashboard={true}/>
          </div>
        )}
        {withDetails && stateDetailsItems && <Details items={stateDetailsItems} />}
        {withCompare && <CompareButton isCompare={isCompare} />}
      </Space>
      <div className="filter-wrapper">
        {isCompare ? (
          <CompareSection filtersFilter={filtersFilter} />
        ) : (
          isFilterVisible &&
          !isNotParamsFilterVisible && (
            <DashboardFilter
              isCompare={isCompare}
              withSegment={withSegments}
              filtersFilter={filtersFilter}
              setUpdateDashboard={setUpdateDashboard}
              fetchDashboardDataButtonVisible={fetchDashboardDataButtonVisible}
              setFetchDashboardDataButtonVisible={setFetchDashboardDataButtonVisible}
            />
          )
        )}
      </div>
    </Space>
  );
};

export default DashboardParams;